import React from 'react';

import { DropdownLayoutProps, OptionsGroup, Option } from 'ui-builder';
import useUiTheme from '../../../uiTheme';

function BaseDropdownLayout(props: DropdownLayoutProps) {
  const uiTheme = useUiTheme();

  const renderOptions = (options: Option[]) => {
    return options && options.map((option) => (
      <option
        key={`dropdown-${option.value}`}
        // @ts-ignore
        value={option.value === undefined ? '' : option.value}
        disabled={option.disabled || false}
      >
        {option.label}
      </option>
    ));
  };

  const renderGroups = () => {
    return (
      <>
        {(props.options as OptionsGroup[])
          .map((group) => {
            return (<optgroup label={group.label}>{renderOptions(group.options)}</optgroup>);
          })}
      </>
    );
  };

  const isGroups = () => {
    return props.options && props.options?.length > 0 && Array.isArray(props.options[0].options);
  };

  return (
    <uiTheme.forms.BaseInputLayout
      name={props.name}
      label={props.label}
      errors={props.errors}
      hideLabel={props.hideLabel}
      hint={props.hint}
    >
      <select
        name={props.name}
        onChange={props.onChangeCallback}
        // @ts-ignore
        value={props.value === undefined ? '' : props.value}
        disabled={props.isDisabled}
        autoComplete="off"
      >
        {isGroups() ? renderGroups() : renderOptions(props.options as Option[])}
      </select>
    </uiTheme.forms.BaseInputLayout>
  );
}

export default BaseDropdownLayout;
